export default __webpack_public_path__ + "static/media/room9.b7dfd75a.jpg";